<template>
<ItpPage
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="Project"
  :modalBindings="b_7315092382398562_modalBindings"
  @close="evh_7315092382398562_close($event, {})"
>
  <MaterialTabs
    v-if="loaded"
  >
    <ItpBox
      alignItems="center"
      class="mr-3"
      slot="tabs-start"
    >
      <b-breadcrumb
        class="m-0 bg-white"
        v-if="loaded"
      >
        <b-breadcrumb-item
          :text="'Projects'|gettext"
          :to="b_4615685607825208_to"
        >
        </b-breadcrumb-item>
        <b-breadcrumb-item
          :text="item.snapshot('code') + ' ' + item.snapshot('name')"
          active
        >
        </b-breadcrumb-item>
      </b-breadcrumb>
      <ItpButton
        variant="default"
        icon="fa-sync-alt"
        :text="'Reload'|gettext"
        :spinning="actions.reload.isRunning"
        class="px-3"
        @click.prevent.stop="evh_8320016629450276_clickPreventStop($event, {})"
      >
      </ItpButton>
      <BtnDeleteResource
        :resource="item"
        no-text
        :dialogHeader="'Delete project'|pgettext('Modal|Header')"
        class="mr-2"
        @success="evh_6705964765214521_success($event, {})"
      >
      </BtnDeleteResource>
    </ItpBox>
    <b-tab
      :title="'General'|gettext"
      class="container float-left"
    >
      <ItpRow>
        <ItpCol
          w="6"
        >
          <UcProjectGeneral
            :project="item"
            :reload="lastLoaded"
            class="pb-5"
            @reload="evh_5477420070495986_reload($event, {})"
          >
          </UcProjectGeneral>
        </ItpCol>
        <ItpCol
          w="6"
        >
          <UcCommentsList
            :parent="item"
            :reload="lastLoaded"
            class="pb-5"
          >
          </UcCommentsList>
          <UcAttachmentsList
            :parent="item"
            :reload="lastLoaded"
            class="pb-5"
          >
          </UcAttachmentsList>
        </ItpCol>
      </ItpRow>
    </b-tab>
  </MaterialTabs>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpPage>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

addRoute(
  {
    name: "project",
    path: "/projects/:id",
    component: "Project",
    params: [{
      name: "id",
      prop: "oid",
    }
      ,
    ]

  }
)

@Component()
export default class Project extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "page",
  };

  beforeCreate() {
  }

  @Prop({
    type: String,
  })
  oid!: string;

  @Watch('oid')
  onOid(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("oid")
  }

  @Prop({
    type: String,
    default: "md",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  item!: any;

  async $$load_item() {
    return this.$fn.fetch('read_project', { asResource: true, parameters: { id: this.oid } })
  }

  ux!: any;
  b_7315092382398562_modalBindings!: any;
  b_4615685607825208_to!: any;
  dataMembers = ['item', 'ux', 'b_7315092382398562_modalBindings', 'b_4615685607825208_to'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        item: null,
        ux: null,
        b_7315092382398562_modalBindings: {
          size: "sm",
        }
        ,
        b_4615685607825208_to: {
          name: "app.projects",
        }
        ,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: [this.item.code || this.item.name
          ,
        this.$fn.gettext("Project")
          ,
        ]
        ,
        icon: this.$config.project.icon,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_4108_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_4108, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_8320016629450276_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_8320016629450276_clickPreventStop.executeFromDOM(this, event, scope);
  }

  async evh_6705964765214521_success(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_6705964765214521_success.executeFromDOM(this, event, scope);
  }

  async evh_5477420070495986_reload(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_5477420070495986_reload.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_4108: actions.CloseModalAction;
    evh_7315092382398562_close_4107: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_8320016629450276_reloadComponentData_4110: actions.ReloadComponentDataAction;
    evh_8320016629450276_clickPreventStop_4109: actions.EventHandlerImpl;
    evh_8320016629450276_clickPreventStop: actions.EventHandlerGroup;
    act_6705964765214521_closeComponent_4112: actions.CloseComponentAction;
    evh_6705964765214521_success_4111: actions.EventHandlerImpl;
    evh_6705964765214521_success: actions.EventHandlerGroup;
    act_5477420070495986_reloadComponentData_4114: actions.ReloadComponentDataAction;
    evh_5477420070495986_reload_4113: actions.EventHandlerImpl;
    evh_5477420070495986_reload: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_4108 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_4108_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_4107 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_4108,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_4107],
      }
    );
    const act_8320016629450276_reloadComponentData_4110 = new actions.ReloadComponentDataAction(
      {
        displayName: "reload",
        events: [],
      }
    );
    const evh_8320016629450276_clickPreventStop_4109 = new actions.EventHandlerImpl(
      {
        action: act_8320016629450276_reloadComponentData_4110,
        event: "click.prevent.stop",
        displayName: "reload",
      }
    );
    const evh_8320016629450276_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_8320016629450276_clickPreventStop_4109],
      }
    );
    const act_6705964765214521_closeComponent_4112 = new actions.CloseComponentAction(
      {
        events: [],
      }
    );
    const evh_6705964765214521_success_4111 = new actions.EventHandlerImpl(
      {
        action: act_6705964765214521_closeComponent_4112,
        event: "success",
        displayName: "closeComponent",
      }
    );
    const evh_6705964765214521_success = new actions.EventHandlerGroup(
      {
        handlers: [evh_6705964765214521_success_4111],
      }
    );
    const act_5477420070495986_reloadComponentData_4114 = new actions.ReloadComponentDataAction(
      {
        events: [],
      }
    );
    const evh_5477420070495986_reload_4113 = new actions.EventHandlerImpl(
      {
        action: act_5477420070495986_reloadComponentData_4114,
        event: "reload",
        displayName: "reloadComponentData",
      }
    );
    const evh_5477420070495986_reload = new actions.EventHandlerGroup(
      {
        handlers: [evh_5477420070495986_reload_4113],
      }
    );
    return {
      act_7315092382398562_closeModal_4108,
      evh_7315092382398562_close_4107,
      evh_7315092382398562_close,
      act_8320016629450276_reloadComponentData_4110,
      evh_8320016629450276_clickPreventStop_4109,
      evh_8320016629450276_clickPreventStop,
      act_6705964765214521_closeComponent_4112,
      evh_6705964765214521_success_4111,
      evh_6705964765214521_success,
      act_5477420070495986_reloadComponentData_4114,
      evh_5477420070495986_reload_4113,
      evh_5477420070495986_reload,
      reload: act_8320016629450276_reloadComponentData_4110,
    }
  }
}

Vue.component("Project", Project);

</script>